/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import * as Types from '../../../../queryTyping';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type RevokePasskeyMutationVariables = Types.Exact<{
  revokePasskeyParams: Types.RevokePasskeyParams;
}>;


export type RevokePasskeyMutation = (
  { __typename?: 'Mutation' }
  & { revokePasskey: (
    { __typename?: 'RevokePasskeyResult' }
    & Pick<Types.RevokePasskeyResult, 'success' | 'message'>
  ) }
);


export const RevokePasskeyDocument = gql`
    mutation RevokePasskey($revokePasskeyParams: RevokePasskeyParams!) {
  revokePasskey(revokePasskeyParams: $revokePasskeyParams) {
    success
    message
  }
}
    `;
export type RevokePasskeyMutationFn = Apollo.MutationFunction<RevokePasskeyMutation, RevokePasskeyMutationVariables>;

/**
 * __useRevokePasskeyMutation__
 *
 * To run a mutation, you first call `useRevokePasskeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokePasskeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokePasskeyMutation, { data, loading, error }] = useRevokePasskeyMutation({
 *   variables: {
 *      revokePasskeyParams: // value for 'revokePasskeyParams'
 *   },
 * });
 */
export function useRevokePasskeyMutation(baseOptions?: Apollo.MutationHookOptions<RevokePasskeyMutation, RevokePasskeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokePasskeyMutation, RevokePasskeyMutationVariables>(RevokePasskeyDocument, options);
      }
export type RevokePasskeyMutationHookResult = ReturnType<typeof useRevokePasskeyMutation>;
export type RevokePasskeyMutationResult = Apollo.MutationResult<RevokePasskeyMutation>;
export type RevokePasskeyMutationOptions = Apollo.BaseMutationOptions<RevokePasskeyMutation, RevokePasskeyMutationVariables>;